module.exports = __webpack_public_path__ + "media/images/cancel-62cfbf3cd6f9311e69051b6a3a157d9b.svg";